var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.noticeText.length)?_c('div',{staticClass:"notice"},[_vm._v("\n  Live room announcement:"+_vm._s(_vm.noticeText)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }